import { render, staticRenderFns } from "./landing-page-collection.vue?vue&type=template&id=e4ce6b50&scoped=true&"
import script from "./landing-page-collection.vue?vue&type=script&lang=js&"
export * from "./landing-page-collection.vue?vue&type=script&lang=js&"
import style0 from "./landing-page-collection.vue?vue&type=style&index=0&id=e4ce6b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ce6b50",
  null
  
)

export default component.exports